import { HeartOutlined, MessageOutlined, StarOutlined } from '@ant-design/icons'
import React from 'react'
import styled from 'styled-components'

interface AlertTypeOption {
  label: string
  value: string
  icon: React.ReactNode
}

const BoldHeartOutlined = styled(HeartOutlined)`
  font-weight: bold;
`

export const alertTypeOptions: AlertTypeOption[] = [
  { label: 'Star Rating', value: 'Star Rating', icon: <StarOutlined /> },
  {
    label: 'Sentiment',
    value: 'Sentiment',
    icon: <BoldHeartOutlined />,
  },
  { label: 'Volume', value: 'Volume', icon: <MessageOutlined /> },
]
